import { render, staticRenderFns } from "./OikWidget.vue?vue&type=template&id=7d1a00f7&scoped=true&"
import script from "./OikWidget.vue?vue&type=script&lang=ts&"
export * from "./OikWidget.vue?vue&type=script&lang=ts&"
import style0 from "./OikWidget.vue?vue&type=style&index=0&id=7d1a00f7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1a00f7",
  null
  
)

export default component.exports